// Blur-quote: quotes crossfade with blur as the tall section scrolls past. Used by king & queen.
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-blur-quote]').forEach(function (wrap) {
    var quotes = Array.prototype.slice.call(wrap.querySelectorAll('.blur-quote__text'));
    var n = quotes.length;
    if (!n) return;
    function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }
    function update() {
      var rect = wrap.getBoundingClientRect();
      var total = wrap.offsetHeight - window.innerHeight;
      var p = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
      var pos = n > 1 ? p * (n - 1) : 0;
      quotes.forEach(function (q, i) {
        var op = clamp(1 - Math.abs(pos - i), 0, 1);
        q.style.opacity = op;
        q.style.filter = 'blur(' + ((1 - op) * 8) + 'px)';
      });
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
